import React from 'react'
import './footer.css'
import logo from "../../assets/logo-black.png"

export default function Footer() {
    return (
        <div className='footer'>
            <div className='footer-top'>
                <div className='footer-logo'>
                    <img src={logo} alt='' />
                </div>
                <div className='footer-links'>
                    <h2>Platform</h2>
                    <div className='footer-link'>
                        <a href='/internships'>Internships</a>
                    </div>
                    <div className='footer-link'>
                        <a href='/events'>Events</a>
                    </div>
                    <div className='footer-link'>
                        <a href='/hackathons'>Hackathons</a>
                    </div>
                    <div className='footer-link'>
                        <a href='/about'>About</a>
                    </div>
                    <div className='footer-link'>
                        <a href='/contact'>Contact</a>
                    </div>
                </div>
                <div className='footer-links'>
                    <h2>Platform</h2>
                    <div className='footer-link'>
                        <a href='/terms-and-conditions'>Terms and Conditions</a>
                    </div>
                    <div className='footer-link'>
                        <a href='/privacy'>Privacy</a>
                    </div>
                    <div className='footer-link'>
                        <a href='/coming-soon'>Courses <p>Soon</p></a>
                    </div>
                    <div className='footer-link'>
                        <a href='/coming-soon'>AI <p>Soon</p></a>
                    </div>
                </div>
            </div>
            <div className='footer-bottom'>
                <div className='footer-legal'>&copy; Copyright 2023 <strong style={{ color: "#000" }}>Winterns</strong>. All Rights Reserved.</div>
                <div className='footer-social'>
                    <div className='footer-social-link'>
                        <a href='https://twitter.com/WinternsDotCo' target='_blank' rel='noreferrer'>
                            <i className="fab fa-twitter"></i>
                        </a>
                    </div>
                    <div className='footer-social-link'>
                        <a href='https://www.linkedin.com/company/winterns/' target='_blank' rel='noreferrer'>
                            <i className="fab fa-linkedin-in"></i>
                        </a>
                    </div>
                    <div className='footer-social-link'>
                        <a href='https://www.instagram.com/winterns.co/' target='_blank' rel='noreferrer'>
                            <i className="fab fa-instagram"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}
